import React from 'react';
import { IconButton, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import './HeatMapYearDropdown.scss';

interface Props {
  selectedMonth: string;
  setSelectedMonth: (month: string) => void;
}

const months = [
  { value: '1', label: 'Jan' },
  { value: '2', label: 'Feb' },
  { value: '3', label: 'Mar' },
  { value: '4', label: 'Apr' },
  { value: '5', label: 'May' },
  { value: '6', label: 'Jun' },
  { value: '7', label: 'Jul' },
  { value: '8', label: 'Aug' },
  { value: '9', label: 'Sep' },
  { value: '10', label: 'Oct' },
  { value: '11', label: 'Nov' },
  { value: '12', label: 'Dec' },
];

const HeatMapMonthDropdown: React.FC<Props> = ({ selectedMonth, setSelectedMonth }) => {
  const monthNumber = Number(selectedMonth);

  const handleSelectChange = (event: SelectChangeEvent<unknown>) => {
    setSelectedMonth(String(event.target.value));
  };

  const handleIncreaseMonth = () => {
    if (monthNumber > 1) {
      setSelectedMonth(String(monthNumber - 1));
    }
  };

  const handleDecreaseMonth = () => {
    if (monthNumber < 12) {
      setSelectedMonth(String(monthNumber + 1));
    }
  };

  return (
    <div className="d-flex align-items-center justify-content-start heatmap_dropdown">
      <div className="d-flex flex-column" style={{ lineHeight: 1 }}>
        <IconButton size="small" onClick={handleIncreaseMonth} disabled={monthNumber <= 1} sx={{ padding: '2px' }}>
          <KeyboardArrowUpIcon fontSize="small" className="heatmap_arrows_icons" />
        </IconButton>

        <IconButton size="small" onClick={handleDecreaseMonth} disabled={monthNumber >= 12} sx={{ padding: '2px' }}>
          <KeyboardArrowDownIcon fontSize="small" className="heatmap_arrows_icons" />
        </IconButton>
      </div>
      <div className="heatmap_divider" />
      <Select
        value={selectedMonth}
        onChange={handleSelectChange}
        IconComponent={ExpandMoreIcon}
        className="year-select"
      >
        {months.map(month => (
          <MenuItem key={month.value} value={month.value} sx={{ fontFamily: 'Poppins, sans-serif' }}>
            {month.label}
          </MenuItem>
        ))}
      </Select>
    </div>
  );
};

export default HeatMapMonthDropdown;
